import { SavingsKpisActionTypes } from './constants';

type SavingsKpisAction = { type: string, payload: {} | string };

export const savingsKpisApiResponseSuccess = (actionType: string, data: any): SavingsKpisAction => ({
    type: SavingsKpisActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const savingsKpisApiResponseError = (actionType: string, error: string): SavingsKpisAction => ({
    type: SavingsKpisActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const savingsKpisGetBaselineCost = (query: string): SavingsKpisAction => ({
    type: SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_COST_REQUEST,
    payload: { query },
});

export const savingsKpisGetBaselineRatedCost = (query: string): SavingsKpisAction => ({
    type: SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_RATED_COST_REQUEST,
    payload: { query },
});

export const savingsKpisGetBaselineCostCount = (query: string): SavingsKpisAction => ({
    type: SavingsKpisActionTypes.GET_SHIPMENTS_BASELINE_COST_COUNT_REQUEST,
    payload: { query },
});

export const savingsKpisGetCostByCarrier = (query: string): SavingsKpisAction => ({
    type: SavingsKpisActionTypes.GET_SHIPMENTS_COST_BY_CARRIER_REQUEST,
    payload: { query },
});

export const savingsKpisGetCostByTimeframe = (query: string): SavingsKpisAction => ({
    type: SavingsKpisActionTypes.GET_SHIPMENTS_COST_BY_TIMEFRAME_REQUEST,
    payload: { query },
});

export const savingsKpisGetCostOverview = (query: string): SavingsKpisAction => ({
    type: SavingsKpisActionTypes.GET_SHIPMENTS_COST_OVERVIEW_REQUEST,
    payload: { query },
});
